module.exports = [{"name":"Cédula de Ciudadanía","code":"CC"},{"name":"Cédula de Extranjería","code":"CE"},{"name":"Pasaporte Extranjero","code":"PE"},{"name":"Carné diplomático","code":"CD"},{"name":"Otro","code":"OT"}]


//////////////////
// WEBPACK FOOTER
// ./src/config/documentTypes.json
// module id = 497
// module chunks = 0